import React from 'react';

export default {
  Layout: ({ children }) => (
    <div>
      <div className="container">{children}</div>
    </div>
  ),

}